import { api } from '../../../api/axios'
import type { Campeonato, CampeonatoFilters, RegraValorInscricao } from '../types'

export interface ListResponse<T> {
  data: T[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

export const campeonatosService = {
  list: (filters: CampeonatoFilters = {}) =>
    api.get<ListResponse<Campeonato>>('/campeonatos', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Campeonato }>(`/campeonatos/${id}`).then(r => r.data.data),

  create: (data: Omit<Campeonato, 'idcampeonato' | 'data_cadastro' | 'clube_nome'>) =>
    api.post<{ data: Campeonato }>('/campeonatos', data).then(r => r.data.data),

  update: (id: number, data: Partial<Omit<Campeonato, 'idcampeonato' | 'data_cadastro' | 'clube_nome'>>) =>
    api.put<{ data: Campeonato }>(`/campeonatos/${id}`, data).then(r => r.data.data),

  delete: (id: number) =>
    api.delete(`/campeonatos/${id}`),

  listRegras: (idcampeonato: number) =>
    api.get<{ data: RegraValorInscricao[] }>(`/campeonatos/${idcampeonato}/regra-valores`).then(r => r.data.data),

  createRegra: (idcampeonato: number, data: Omit<RegraValorInscricao, 'idregra_valor_inscricao' | 'idcampeonato'>) =>
    api.post<{ data: RegraValorInscricao }>(`/campeonatos/${idcampeonato}/regra-valores`, data).then(r => r.data.data),

  updateRegra: (id: number, data: Partial<Omit<RegraValorInscricao, 'idregra_valor_inscricao' | 'idcampeonato'>>) =>
    api.put<{ data: RegraValorInscricao }>(`/regra-valores/${id}`, data).then(r => r.data.data),

  deleteRegra: (id: number) =>
    api.delete(`/regra-valores/${id}`),
}
